// Required imports
import documentReady from './common/actions';
import { addHeaderClickListener, headerAnimation } from './common/header';
import { recordMouseClickEvents } from './common/analytics';
import {
  isMobileBrowser,
  mobileBrowserRedirectionUrl,
} from './common/mobile-utils';

const { location } = window;

function onFreeTier() {
  if (isMobileBrowser()) {
    location.href = mobileBrowserRedirectionUrl(location);
    return;
  }
  // redirecting to login page 
  // location.href = `https://signup.${location.host}/signup/free`;
  location.href = `https://${location.host}/login`;
}

function onProTier() {
  if (isMobileBrowser()) {
    location.href = mobileBrowserRedirectionUrl(location);
    return;
  }
  // location.href = `https://signup.${location.host}/signup?planId=4997`;
  location.href = `https://${location.host}/login`;
}

function onBusinessTier() {
  if (isMobileBrowser()) {
    location.href = mobileBrowserRedirectionUrl(location);
    return;
  }
  // location.href = `https://signup.${location.host}/signup?planId=4998`;
  location.href = `https://${location.host}/login`;
}

function callBack() {
  addHeaderClickListener();
  headerAnimation();
  document.getElementById('getStartedFree').onclick = onFreeTier;
  document.getElementById('getStartedPro').onclick = onProTier;
  document.getElementById('getStartedBusiness').onclick = onBusinessTier;
  window.addEventListener('click', recordMouseClickEvents);
}

documentReady(callBack);
